var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-print": false,
              "show-new": false,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("audit-trail-list-side-menu", {
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "tile is-parent" }, [
                _c(
                  "article",
                  { staticClass: "tile is-child box" },
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "total-rows": _vm.totalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(_vm.entitySummaries, function (entity, index) {
                          return _c(
                            "tr",
                            {
                              key: entity.auditTrailFieldId,
                              class: {
                                "is-selected": _vm.selectedRow === index,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelected(index, $event)
                                },
                              },
                            },
                            [
                              _c("td", [
                                _vm._v(_vm._s(entity.entityShortName) + " "),
                              ]),
                              _c("td", [_vm._v(_vm._s(entity.auditReference))]),
                              _c("td", [_vm._v(_vm._s(entity.fieldName))]),
                              _c("td", [_vm._v(_vm._s(entity.operation))]),
                              _c("td", { staticClass: "col-message" }, [
                                !_vm.isNewValue(
                                  entity.operation,
                                  entity.oldValue,
                                  entity.entityShortName,
                                  entity.fieldName
                                )
                                  ? _c("div", [
                                      _vm._v(
                                        " " + _vm._s(entity.oldValue) + " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _c("td", { staticClass: "col-message" }, [
                                _vm.isNewValue(
                                  entity.operation,
                                  entity.newValue,
                                  entity.entityShortName,
                                  entity.fieldName
                                )
                                  ? _c("div", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.generateUrl(
                                              entity.auditTrailFieldId
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.edit(
                                                entity.auditTrailFieldId,
                                                $event
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" View XML ")]
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.isNewValue(
                                  entity.operation,
                                  entity.newValue,
                                  entity.entityShortName,
                                  entity.fieldName
                                )
                                  ? _c("div", [
                                      _vm._v(
                                        " " + _vm._s(entity.newValue) + " "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              _c("td", [_vm._v(_vm._s(entity.userName))]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimeLocale(
                                      entity.occurredAt,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _vm.isNewValue(
                                  entity.operation,
                                  entity.newValue,
                                  entity.entityShortName,
                                  entity.fieldName
                                )
                                  ? _c("div", [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button is-primary is-small is-inverted tooltip",
                                          attrs: {
                                            href: _vm.generateUrl(
                                              entity.auditTrailFieldId
                                            ),
                                            "data-tooltip": "Click to view",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.edit(
                                                entity.auditTrailFieldId,
                                                $event
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "icon is-medium" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "mdi mdi-file-eye mdi-24px",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                !_vm.isNewValue(
                                  entity.operation,
                                  entity.newValue,
                                  entity.entityShortName,
                                  entity.fieldName
                                )
                                  ? _c("div")
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }